import React, { Component } from 'react';

import './style.scss';
export default class RequestCall extends Component {
  componentDidMount() {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);
    
    script.addEventListener('load', () => {
    	if(window.hbspt) {
      	window.hbspt.forms.create({
        	portalId: '4344380',
          formId: 'ebc77a24-995c-4086-a390-2824bedb638f',
          target: '#hubspotForm'
        })
      }
    });
  }

  render() {

    return (
      <div className="aboss__call">
        <div className="aboss__call_content">
          <h1>Schedule a 15-20 minute<br />video call for ABOSS Agency</h1>
          <div id="hubspotForm"></div>
        </div>
      </div>
    );

  }
}


// WEBPACK FOOTER //
// src/views/request-call/index.js